import { useEffect } from 'react'

import { startDatadogView, stopDatadogView } from './datadogRum'
import { DatadogRumLocation } from './types'

export const useDatadogRumView = (
  location: DatadogRumLocation,
  enabled = true
) => {
  const pathname = location?.pathname

  useEffect(() => {
    if (!enabled || !pathname) {
      return
    }

    startDatadogView(pathname)

    return () => {
      stopDatadogView(pathname)
    }
  }, [pathname, enabled])
}
